import { $config } from "@/tenant/config";

const routes = [
  {
    name: "support",
    path: "/support",
    alias: "/VUE_APP_DOT_SUPPORT_APP",
    beforeEnter: (to, from) => {
      window.location.href = $config.getExternalUrl(to.path);
    },
  },
];

const externalUrls = {
  local: {
    "/support": "support.dev-nls.apps-dotincorp.com",
    "/account": "account.dev-nls.apps-dotincorp.com",
  },
  dev: {
    "/support": "support.dev-nls.apps-dotincorp.com",
    "/account": "account.dev-nls.apps-dotincorp.com",
  },
  real: {
    "/support": "support.nls.apps-dotincorp.com",
    "/account": "account.nls.apps-dotincorp.com",
  },
};

export { routes as default, externalUrls };
